import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/icon-income.svg'
import _imports_1 from '@/assets/img/icon/icon-delivery.svg'
import _imports_2 from '@/assets/img/icon/icon-received.svg'
import _imports_3 from '@/assets/img/icon/icon-claim.svg'


const _hoisted_1 = { class: "grid lg:grid-cols-4 md:grid-cols-4 grid-cols-2 lg:gap-4 md:gap-4 gap-2" }
const _hoisted_2 = { class: "bg-white shadow p-4 rounded-md flex items-center justify-between" }
const _hoisted_3 = { class: "detail-card-accumulate mr-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "lg:text-base md:text-base text-sm color-black font-bold mb-1" }, "Total Komisi Agen", -1)
const _hoisted_5 = { class: "font-bold break-all" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  alt: "total pendapatan",
  src: _imports_0,
  class: "lg:w-12 md:w-10 w-9"
}, null, -1)
const _hoisted_7 = { class: "bg-white shadow p-4 rounded-md flex items-center justify-between" }
const _hoisted_8 = { class: "detail-card-accumulate mr-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "lg:text-base md:text-base text-sm color-black font-bold mb-1" }, "Total Pengiriman", -1)
const _hoisted_10 = { class: "font-bold break-all" }
const _hoisted_11 = /*#__PURE__*/_createVNode("small", { class: "font-normal lg:text-base md:text-base text-sm" }, "Resi", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  alt: "total pengiriman",
  src: _imports_1,
  class: "lg:w-12 md:w-10 w-9"
}, null, -1)
const _hoisted_13 = { class: "bg-white shadow p-4 rounded-md flex items-center justify-between" }
const _hoisted_14 = { class: "detail-card-accumulate mr-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "lg:text-base md:text-base text-sm color-black font-bold mb-1" }, "Total Penerimaan", -1)
const _hoisted_16 = { class: "font-bold break-all" }
const _hoisted_17 = /*#__PURE__*/_createVNode("small", { class: "font-normal lg:text-base md:text-base text-sm" }, "Resi", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  alt: "total penerimaan",
  src: _imports_2,
  class: "lg:w-12 md:w-10 w-9"
}, null, -1)
const _hoisted_19 = { class: "bg-white shadow p-4 rounded-md flex items-center justify-between" }
const _hoisted_20 = { class: "detail-card-accumulate mr-2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "lg:text-base md:text-base text-sm color-black font-bold mb-1" }, "Total Klaim", -1)
const _hoisted_22 = { class: "font-bold break-all" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  alt: "total klaim",
  src: _imports_3,
  class: "lg:w-12 md:w-10 w-9"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("h5", _hoisted_5, "Rp. " + _toDisplayString(new Number(_ctx.income).toLocaleString("id-ID")), 1)
      ]),
      _hoisted_6
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("h5", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.deliveryTotal) + " ", 1),
          _hoisted_11
        ])
      ]),
      _hoisted_12
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("h5", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.receiveTotal) + " ", 1),
          _hoisted_17
        ])
      ]),
      _hoisted_18
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode("h5", _hoisted_22, "Rp. " + _toDisplayString(new Number(_ctx.claimTotal).toLocaleString("id-ID")), 1)
      ]),
      _hoisted_23
    ])
  ]))
}